import React from 'react';
import moment from 'moment';
import {
  GetWorkerCardsDocument,
  useAddCardToWorkerMutation,
} from 'apollo/generated/client-operations';
import { useIsMounted } from 'utils';
import { getGraphQLError } from 'utils/error';
import { CheckIcon } from 'components/icons';
import { FormOnSubmit, ModalFormContent } from 'components/form';
import { AlertService } from 'components/alertService';
import { AssignQRFormData } from './assignQRModalContent/types';

export type ReassignQRModalContentProps = {
  setOpen: () => void;
  onAction: () => void;
  jobsiteId: string;
  workerId: string;
  assignQRData: AssignQRFormData;
  workerCardFormatId: string;
};

export function ReassignQRModalContent(
  props: ReassignQRModalContentProps,
): React.ReactElement {
  const {
    setOpen,
    onAction,
    jobsiteId,
    workerId,
    assignQRData,
    workerCardFormatId,
  } = props;

  const isMounted = useIsMounted();
  const [isFetching, setIsFetching] = React.useState<boolean>(false);

  const [addCardToWorker] = useAddCardToWorkerMutation({
    refetchQueries: [GetWorkerCardsDocument],
  });

  const onSubmit: FormOnSubmit<unknown> = async (
    _data,
    event,
  ): Promise<void> => {
    if (isFetching) {
      return;
    }

    setIsFetching(true);

    const { qrCodeNumber } = assignQRData;

    try {
      await addCardToWorker({
        variables: {
          workerId,
          jobsiteId,
          forceCreate: true,
          workerCardInput: {
            cardNumber: qrCodeNumber,
            workerCardFormatId,
            isTemporary: false,
            startDate: moment().toDate(),
            endDate: null,
            cardIssueReason: null,
          },
        },
      });
      onAction();
      AlertService.alert('success', 'Success', 'QR Code assigned');
    } catch (error) {
      event.preventDefault();
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(error),
      );
    } finally {
      if (isMounted()) {
        setIsFetching(false);
      }
    }
  };

  return (
    <ModalFormContent
      loading={isFetching}
      setOpen={setOpen}
      inputs={null}
      onSubmit={onSubmit}
      inputsContainerClassName="odin-grid odin-grid-cols-6 odin-gap-6"
      actionText="Yes"
      actionIcon={CheckIcon}
      cancelText="No"
      actionButtonWithSpinner={isFetching}
    />
  );
}
